import { ProgressSpinner } from 'primereact/progressspinner';

const CircularProgressWithPercentage: React.FC<{ progress: number }> = ({ progress }) => {
  const radius = 45;
  const strokeWidth = 6;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;
  return (
    <div style={{ position: 'relative', width: '150px' }}>
      <div
        style={{
          scale: '0.34',
          marginTop: '-2px',
        }}
      >
        <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle
            cx="50"
            cy="50"
            r={radius}
            stroke="#e6e6e6"
            strokeWidth={strokeWidth}
            fill="transparent"
          />
          <circle
            cx="50"
            cy="50"
            r={radius}
            stroke="#007bff"
            strokeWidth={strokeWidth}
            fill="transparent"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
            style={{ transition: 'stroke-dashoffset 0.5s ease' }}
          />
        </svg>
      </div>

      <div
        className="progress-text"
        style={{
          position: 'absolute',
          top: '49%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#fff',
          textAlign: 'center',
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {progress.toFixed(1)}%
      </div>
    </div>
  );
};
interface CircularProgressProps {
  value: number;
  loading: boolean;
  toggleFunction: () => void;
}
const CircularProgress: React.FC<CircularProgressProps> = ({ value, loading, toggleFunction }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={toggleFunction}
    >
      {loading ? (
        <ProgressSpinner
          style={{
            width: '50px',
            height: '50px',
            padding: 0,
            margin: 0,
          }}
          strokeWidth="4"
          animationDuration="1s"
        />
      ) : (
        <CircularProgressWithPercentage progress={value} />
      )}
    </div>
  );
};
export default CircularProgress;
